<template>
  <v-card>
    <v-card-title>
      Add Event Admin
    </v-card-title>

    <v-form
      @submit="addAdminToEvent"
    >
      <v-container>
        <v-row>
          <v-col>
            <v-select
              v-model="admin"
              :items="committee"
              item-text="name"
              item-value="email"
              label="Admin"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="2"
          >
            <v-btn
              type="submit"
            >
              Add Admin
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CommitteeClient from '@/api/CommitteeClient';
import AdminClient from '@/api/AdminClient';
import EventsClient from '@/api/EventsClient';

export default {
  name: 'AdminAdd',
  data() {
    return {
      admin: null,
      committee: [],
      adminClient: null,
      committeeClient: null,
      eventsClient: null,
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
      currentHackathonId: 'currentHackathonId',
    }),
  },
  async mounted() {
    this.committeeClient = new CommitteeClient(this.currentJwtToken);
    await this.getCommitteeMembers();
    this.adminClient = new AdminClient(this.currentJwtToken);
    this.eventsClient = new EventsClient(this.currentJwtToken);
  },
  methods: {
    ...mapActions({
      setEvent: 'setEvent',
    }),
    async getCommitteeMembers() {
      const responseData = await this.committeeClient.getCommitteeMembers();
      this.committee = responseData;
    },
    async addAdminToEvent(form) {
      form.preventDefault();
      if (this.admin !== null) {
        /* eslint-disable-next-line max-len */
        await this.adminClient.addAdmin(this.currentHackathonId, this.admin);
        const updatedEvent = await this.eventsClient.getEvent(this.currentHackathonId);
        this.setEvent(updatedEvent);
        this.$router.go();
      }
    },
  },
};
</script>
